import { render, staticRenderFns } from "./IconSvg.vue?vue&type=template&id=24b647d5&"
import script from "./IconSvg.vue?vue&type=script&lang=js&"
export * from "./IconSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports